import React from 'react';
import { CustomLink, Footer } from '../..';
import { InfoPopup } from '../../../domain/Mailbox/parts/InfoPopup/InfoPopup';
import { FormattedMessage } from 'react-intl';
import { ConfigContext } from '../../../providers';
import { staticConfig } from '../../../config';
import styles from './exempted.module.scss';

const classicLogonPlace = localStorage.getItem('classicLogonPlace');
const classicOverviewLink = staticConfig.classicOverviewLink.replace('{domainType}', classicLogonPlace);

interface IExempted {
    isBorger: boolean;
}

export default function Exempted(props: IExempted) {
    const { isBorger } = props;

    return (
        <ConfigContext.Consumer>
            {(config): JSX.Element => (
                <div className="w-100">
                    <InfoPopup
                        type="info"
                        title="EXEMPT_POPUP_HEADER"
                        onClose={() => window.location.replace(classicOverviewLink)}
                    >
                        <div key="exemptMsgGeneral">
                            <FormattedMessage
                                id="EXEMPT_POPUP_TEXT"
                                values={{
                                    ddpLink: (
                                        <CustomLink
                                            href={
                                                isBorger
                                                    ? config.links.digitalPost.borger.link
                                                    : config.links.digitalPost.virk.link
                                            }
                                            target="_blank"
                                        >
                                            {isBorger
                                                ? config.links.digitalPost.borger.label
                                                : config.links.digitalPost.virk.label}
                                        </CustomLink>
                                    ),
                                }}
                            />
                        </div>
                    </InfoPopup>
                    <div className={styles.footerSection}>
                        <Footer />
                    </div>
                </div>
            )}
        </ConfigContext.Consumer>
    );
}
